import { render, staticRenderFns } from "./PageMediaTable.vue?vue&type=template&id=563be0fa&scoped=true&"
import script from "./PageMediaTable.vue?vue&type=script&lang=js&"
export * from "./PageMediaTable.vue?vue&type=script&lang=js&"
import style0 from "./PageMediaTable.vue?vue&type=style&index=0&id=563be0fa&lang=stylus&scoped=true&"
import style1 from "./PageMediaTable.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563be0fa",
  null
  
)

export default component.exports